var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6674 1.25C3.67545 1.25 1.25 3.67545 1.25 6.6674C1.25 8.41718 2.07888 9.97309 3.36798 10.9645C3.60089 11.1437 3.84867 11.3042 4.10911 11.444L9.19756 11.459C9.4683 11.3157 9.72555 11.1501 9.96683 10.9645C11.2559 9.97309 12.0848 8.41718 12.0848 6.6674C12.0848 3.67545 9.65935 1.25 6.6674 1.25ZM8.75172 12.7077L4.58309 12.6954V13.75H8.75172V12.7077ZM3.33309 12.4424C3.07962 12.2957 2.83676 12.1329 2.60592 11.9554C1.02242 10.7375 0 8.82172 0 6.6674C0 2.9851 2.9851 0 6.6674 0C10.3497 0 13.3348 2.9851 13.3348 6.6674C13.3348 8.82172 12.3124 10.7375 10.7289 11.9554C10.498 12.1329 10.2552 12.2957 10.0017 12.4424V15H3.33309V12.4424ZM3.33481 16.25H10.0015V17.5H3.33481V16.25Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.f749f6b8692de42ddbabb75856be8295.svg";
export { ForwardRef as ReactComponent };